// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type LoginErrorContextProperties = {
  error_type: string;
  error_message?: string;
  error_code?: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/login_error_context/jsonschema/2-0-0';
export const loginErrorContextName = 'login_error_context';
export class LoginErrorContext extends BaseTrackingContext<LoginErrorContextProperties> {
  constructor(properties: LoginErrorContextProperties) {
    super(loginErrorContextName, schema, properties);
  }
}
